// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.landing-page {
  position: relative;
  height: 100%;
  min-height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: var(--color-neutral);
  background-size: 800px 800px;
  background-position: top left;
  background-repeat: repeat;
  color: var(--color-text);
}

.landing-page__nav {
  position: sticky;
  top: 0.85rem;
  z-index: 10;
  width: min(calc(100% - 2rem), 1100px);
  margin: 0.85rem auto 0;
  border: 1px solid var(--color-border);
  border-radius: 999px;
  background: color-mix(in srgb, var(--color-surface-raised) 88%, transparent);
  box-shadow: var(--shadow);
  backdrop-filter: blur(12px);
}

.landing-page__nav-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
  margin: 0;
  padding: 0.65rem 0.85rem 0.65rem 1rem;
}

.landing-page__brand {
  display: inline-flex;
  align-items: center;
  gap: 0.65rem;
  min-width: 0;
  color: var(--color-text);
}

.landing-page__logo {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border: 1px solid var(--color-border);
  border-radius: 10px;
  background: #ffffff;
  box-shadow: var(--shadow);
  overflow: hidden;
}

.landing-page__logo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.landing-page__brand-name {
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.landing-page__links {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.landing-page__link {
  padding: 0;
  border: none;
  background: transparent;
  color: var(--color-text-muted);
  font: inherit;
  font-size: 0.92rem;
  cursor: pointer;
  transition: color 0.2s ease;
}

.landing-page__link:hover {
  color: var(--color-text);
}

.landing-page__nav-actions {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  flex-shrink: 0;
}

.landing-page__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem 1.35rem;
  border: none;
  border-radius: var(--radius);
  background: var(--color-btn);
  color: var(--color-btn-text);
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  cursor: pointer;
  transition: filter 0.2s ease, background 0.2s ease;
}

.landing-page__btn:hover:not(:disabled) {
  filter: brightness(1.08);
  background: var(--color-btn-hover);
}

.landing-page__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.landing-page__btn--nav {
  padding: 0.65rem 1.1rem;
}

.landing-page__main {
  width: min(100%, 1100px);
  margin: 0 auto;
  padding: 0 max(1.25rem, env(safe-area-inset-right, 0px))
    0 max(1.25rem, env(safe-area-inset-left, 0px));
}

.landing-page__features,
.landing-page__contact,
.landing-page__main {
  scroll-margin-top: 5rem;
}

.landing-page__section-card {
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  background: var(--color-surface-raised);
  box-shadow: var(--shadow);
}

.landing-page__hero {
  padding: 1.75rem 0 1.25rem;
}

.landing-page__hero-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 2.75rem 1.75rem;
}

.landing-page__hero-card h1 {
  margin: 0;
  max-width: 16ch;
  font-size: clamp(2rem, 4.5vw, 3.15rem);
  font-weight: 700;
  line-height: 1.15;
  letter-spacing: -0.02em;
  color: var(--color-text);
}

.landing-page__hero-card > p {
  margin: 1.15rem 0 0;
  max-width: 42rem;
  color: var(--color-text-muted);
  font-size: clamp(0.95rem, 1.5vw, 1.1rem);
  line-height: 1.6;
}

.landing-page__hero-card .landing-page__btn {
  margin-top: 1.75rem;
}

.landing-page__features {
  padding: 1.25rem 0;
}

.landing-page__features > .landing-page__section-card {
  padding: 1.75rem 1.5rem;
}

.landing-page__features-heading {
  margin: 0 0 1.5rem;
  text-align: center;
  font-size: clamp(1.35rem, 2.5vw, 1.85rem);
  font-weight: 700;
  line-height: 1.25;
  letter-spacing: -0.02em;
  color: var(--color-text);
}

.landing-page__features-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1.25rem;
}

.landing-page__feature-card {
  padding: 1.35rem 1.2rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  background: var(--color-surface);
}

.landing-page__feature-card h3 {
  margin: 0 0 0.65rem;
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--color-text);
}

.landing-page__feature-card p {
  margin: 0;
  color: var(--color-text-muted);
  font-size: 0.9rem;
  line-height: 1.55;
}

.landing-page__contact {
  display: flex;
  justify-content: center;
  padding: 1.25rem 0 2.5rem;
}

.landing-page__contact-card {
  width: min(100%, 560px);
  padding: 1.75rem 1.5rem 1.5rem;
}

.landing-page__contact-card > h2 {
  margin: 0 0 1.35rem;
  text-align: center;
  font-size: 1.35rem;
  font-weight: 700;
}

.landing-page__contact-card .data-page__modal-field textarea {
  width: 100%;
  min-height: 120px;
  padding: 0.75rem 0.85rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  background: var(--color-surface);
  color: var(--color-text);
  font: inherit;
  line-height: 1.45;
  resize: vertical;
}

.landing-page__contact-card .data-page__modal-field textarea:focus {
  outline: none;
  border-color: var(--color-accent);
  box-shadow: 0 0 0 3px var(--color-accent-soft);
}

.landing-page__contact-card .data-page__modal-field textarea[aria-invalid='true'] {
  border-color: var(--color-secondary);
}

.landing-page__contact-card .data-page__field-error {
  margin-top: 0.35rem;
}

.landing-page__btn--submit {
  margin-top: 0.35rem;
}

.landing-page__contact-success {
  margin: 0.85rem 0 0;
  color: var(--color-accent);
  font-size: 0.92rem;
  font-weight: 600;
  text-align: center;
  line-height: 1.4;
}

.landing-page__footer {
  padding: 1.5rem 1.25rem max(2rem, env(safe-area-inset-bottom, 0px));
  text-align: center;
}

.landing-page__footer p {
  margin: 0;
  color: var(--color-text-muted);
  font-size: 0.82rem;
}

@media (max-width: 900px) {
  .landing-page__features-grid {
    grid-template-columns: 1fr;
  }

  .landing-page__hero-card {
    padding: 2.25rem 1.35rem;
  }
}

@media (max-width: 720px) {
  .landing-page__nav {
    width: min(calc(100% - 1.5rem), 1100px);
    margin-top: 0.75rem;
    border-radius: 20px;
  }

  .landing-page__nav-inner {
    flex-wrap: wrap;
    row-gap: 0.55rem;
    padding: 0.7rem 0.75rem;
  }

  .landing-page__links {
    order: 3;
    width: 100%;
    justify-content: center;
    gap: 1.25rem;
    padding-top: 0.15rem;
    border-top: 1px solid var(--color-border);
  }

  .landing-page__brand-name {
    font-size: 0.85rem;
  }

  .landing-page__features > .landing-page__section-card,
  .landing-page__contact-card {
    padding: 1.5rem 1.15rem 1.25rem;
  }
}

@media (max-width: 480px) {
  .landing-page__nav {
    width: min(calc(100% - 1rem), 1100px);
    top: 0.55rem;
    margin-top: 0.55rem;
  }

  .landing-page__main {
    padding-left: max(0.85rem, env(safe-area-inset-left, 0px));
    padding-right: max(0.85rem, env(safe-area-inset-right, 0px));
  }

  .landing-page__hero-card h1 {
    max-width: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Landing.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;EACtC,4BAA4B;EAC5B,6BAA6B;EAC7B,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,qCAAqC;EACrC,sBAAsB;EACtB,qCAAqC;EACrC,oBAAoB;EACpB,4EAA4E;EAC5E,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,YAAY;EACZ,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd;kDACgD;AAClD;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;EAC5B,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,wBAAwB;EACxB,qCAAqC;EACrC,4BAA4B;EAC5B,gCAAgC;EAChC,wBAAwB;EACxB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mEAAmE;EACnE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,uCAAuC;IACvC,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,QAAQ;IACR,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,oBAAoB;IACpB,yCAAyC;EAC3C;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,0DAA0D;IAC1D,4DAA4D;EAC9D;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".landing-page {\n  position: relative;\n  height: 100%;\n  min-height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  background-color: var(--color-neutral);\n  background-size: 800px 800px;\n  background-position: top left;\n  background-repeat: repeat;\n  color: var(--color-text);\n}\n\n.landing-page__nav {\n  position: sticky;\n  top: 0.85rem;\n  z-index: 10;\n  width: min(calc(100% - 2rem), 1100px);\n  margin: 0.85rem auto 0;\n  border: 1px solid var(--color-border);\n  border-radius: 999px;\n  background: color-mix(in srgb, var(--color-surface-raised) 88%, transparent);\n  box-shadow: var(--shadow);\n  backdrop-filter: blur(12px);\n}\n\n.landing-page__nav-inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  width: 100%;\n  margin: 0;\n  padding: 0.65rem 0.85rem 0.65rem 1rem;\n}\n\n.landing-page__brand {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.65rem;\n  min-width: 0;\n  color: var(--color-text);\n}\n\n.landing-page__logo {\n  display: grid;\n  place-items: center;\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  border: 1px solid var(--color-border);\n  border-radius: 10px;\n  background: #ffffff;\n  box-shadow: var(--shadow);\n  overflow: hidden;\n}\n\n.landing-page__logo img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.landing-page__brand-name {\n  font-size: 0.95rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.landing-page__links {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n}\n\n.landing-page__link {\n  padding: 0;\n  border: none;\n  background: transparent;\n  color: var(--color-text-muted);\n  font: inherit;\n  font-size: 0.92rem;\n  cursor: pointer;\n  transition: color 0.2s ease;\n}\n\n.landing-page__link:hover {\n  color: var(--color-text);\n}\n\n.landing-page__nav-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  flex-shrink: 0;\n}\n\n.landing-page__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.75rem 1.35rem;\n  border: none;\n  border-radius: var(--radius);\n  background: var(--color-btn);\n  color: var(--color-btn-text);\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: filter 0.2s ease, background 0.2s ease;\n}\n\n.landing-page__btn:hover:not(:disabled) {\n  filter: brightness(1.08);\n  background: var(--color-btn-hover);\n}\n\n.landing-page__btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.landing-page__btn--nav {\n  padding: 0.65rem 1.1rem;\n}\n\n.landing-page__main {\n  width: min(100%, 1100px);\n  margin: 0 auto;\n  padding: 0 max(1.25rem, env(safe-area-inset-right, 0px))\n    0 max(1.25rem, env(safe-area-inset-left, 0px));\n}\n\n.landing-page__features,\n.landing-page__contact,\n.landing-page__main {\n  scroll-margin-top: 5rem;\n}\n\n.landing-page__section-card {\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  background: var(--color-surface-raised);\n  box-shadow: var(--shadow);\n}\n\n.landing-page__hero {\n  padding: 1.75rem 0 1.25rem;\n}\n\n.landing-page__hero-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 2.75rem 1.75rem;\n}\n\n.landing-page__hero-card h1 {\n  margin: 0;\n  max-width: 16ch;\n  font-size: clamp(2rem, 4.5vw, 3.15rem);\n  font-weight: 700;\n  line-height: 1.15;\n  letter-spacing: -0.02em;\n  color: var(--color-text);\n}\n\n.landing-page__hero-card > p {\n  margin: 1.15rem 0 0;\n  max-width: 42rem;\n  color: var(--color-text-muted);\n  font-size: clamp(0.95rem, 1.5vw, 1.1rem);\n  line-height: 1.6;\n}\n\n.landing-page__hero-card .landing-page__btn {\n  margin-top: 1.75rem;\n}\n\n.landing-page__features {\n  padding: 1.25rem 0;\n}\n\n.landing-page__features > .landing-page__section-card {\n  padding: 1.75rem 1.5rem;\n}\n\n.landing-page__features-heading {\n  margin: 0 0 1.5rem;\n  text-align: center;\n  font-size: clamp(1.35rem, 2.5vw, 1.85rem);\n  font-weight: 700;\n  line-height: 1.25;\n  letter-spacing: -0.02em;\n  color: var(--color-text);\n}\n\n.landing-page__features-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 1.25rem;\n}\n\n.landing-page__feature-card {\n  padding: 1.35rem 1.2rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  background: var(--color-surface);\n}\n\n.landing-page__feature-card h3 {\n  margin: 0 0 0.65rem;\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: var(--color-text);\n}\n\n.landing-page__feature-card p {\n  margin: 0;\n  color: var(--color-text-muted);\n  font-size: 0.9rem;\n  line-height: 1.55;\n}\n\n.landing-page__contact {\n  display: flex;\n  justify-content: center;\n  padding: 1.25rem 0 2.5rem;\n}\n\n.landing-page__contact-card {\n  width: min(100%, 560px);\n  padding: 1.75rem 1.5rem 1.5rem;\n}\n\n.landing-page__contact-card > h2 {\n  margin: 0 0 1.35rem;\n  text-align: center;\n  font-size: 1.35rem;\n  font-weight: 700;\n}\n\n.landing-page__contact-card .data-page__modal-field textarea {\n  width: 100%;\n  min-height: 120px;\n  padding: 0.75rem 0.85rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  background: var(--color-surface);\n  color: var(--color-text);\n  font: inherit;\n  line-height: 1.45;\n  resize: vertical;\n}\n\n.landing-page__contact-card .data-page__modal-field textarea:focus {\n  outline: none;\n  border-color: var(--color-accent);\n  box-shadow: 0 0 0 3px var(--color-accent-soft);\n}\n\n.landing-page__contact-card .data-page__modal-field textarea[aria-invalid='true'] {\n  border-color: var(--color-secondary);\n}\n\n.landing-page__contact-card .data-page__field-error {\n  margin-top: 0.35rem;\n}\n\n.landing-page__btn--submit {\n  margin-top: 0.35rem;\n}\n\n.landing-page__contact-success {\n  margin: 0.85rem 0 0;\n  color: var(--color-accent);\n  font-size: 0.92rem;\n  font-weight: 600;\n  text-align: center;\n  line-height: 1.4;\n}\n\n.landing-page__footer {\n  padding: 1.5rem 1.25rem max(2rem, env(safe-area-inset-bottom, 0px));\n  text-align: center;\n}\n\n.landing-page__footer p {\n  margin: 0;\n  color: var(--color-text-muted);\n  font-size: 0.82rem;\n}\n\n@media (max-width: 900px) {\n  .landing-page__features-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .landing-page__hero-card {\n    padding: 2.25rem 1.35rem;\n  }\n}\n\n@media (max-width: 720px) {\n  .landing-page__nav {\n    width: min(calc(100% - 1.5rem), 1100px);\n    margin-top: 0.75rem;\n    border-radius: 20px;\n  }\n\n  .landing-page__nav-inner {\n    flex-wrap: wrap;\n    row-gap: 0.55rem;\n    padding: 0.7rem 0.75rem;\n  }\n\n  .landing-page__links {\n    order: 3;\n    width: 100%;\n    justify-content: center;\n    gap: 1.25rem;\n    padding-top: 0.15rem;\n    border-top: 1px solid var(--color-border);\n  }\n\n  .landing-page__brand-name {\n    font-size: 0.85rem;\n  }\n\n  .landing-page__features > .landing-page__section-card,\n  .landing-page__contact-card {\n    padding: 1.5rem 1.15rem 1.25rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .landing-page__nav {\n    width: min(calc(100% - 1rem), 1100px);\n    top: 0.55rem;\n    margin-top: 0.55rem;\n  }\n\n  .landing-page__main {\n    padding-left: max(0.85rem, env(safe-area-inset-left, 0px));\n    padding-right: max(0.85rem, env(safe-area-inset-right, 0px));\n  }\n\n  .landing-page__hero-card h1 {\n    max-width: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
